import styled from 'styled-components';
import { Layout } from 'antd';
const { Header } = Layout;

export type HeaderProps = { src: string | undefined };

export const StyledHeader = styled(Header)`
  height: auto;
  background: none;
  padding: 0;
`;

const Image =
    styled.img.attrs<HeaderProps>((props: HeaderProps) => ({
      src: props.src,
    }))`
    display: block;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    vertical-align: top;
    border-style: solid;
    max-width: 100%;
    border-width: 0;
    border-color: #9c9c9c;
`;

export default Image;
